import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Carousel } from 'react-responsive-carousel'
import MoreOptions from "./components/MoreOptions";
import MediaPreview from "./components/MediaPreview";
import TitlePreview from "./components/TitlePreview";
import TextPreview from "./components/TextPreview";
import AddAssetButton from "./components/AddAssetButton";
import BoardDropdown from "./components/BoardDropdown";
import LinkPreview from "./components/LinkPreview";
import { getImageDimensions } from "utils/getImageWidthHeight";
import { getAspectRatio } from "utils/getAspectRatio";
import { TbScreenshot } from "react-icons/tb";
import { Tooltip } from "components/ui";

const PinterestPreview = (post) => {

    const {
        id,
        user_id,
        user_name,
        username,
        user_image,
        created_at,
        text,
        media,
        like_count,
        comment_count,
        view_count,
        retweet_count,
        className,
        title,
        preferences,
        link,

        assets,
        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onTitleEdit, 
        onLinkEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        onPreferencesEdit,
        onCoverEdit,
        allPosts = []
    } = post;

    const network = "pinterest";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == network)?.[0];

    const carouselRef = useRef();
    const [ assetQuantity, setAssetQuantity ] = useState(assets?.length);
    const [ aspectRatioCarousel, setAspectRatioCarousel ] = useState("aspect-square");

    useEffect(() => {
        if (assetQuantity && carouselRef.current) {
            if (assetQuantity < assets?.length) {
                carouselRef.current?.moveTo(assets?.length - 1);
            }
            setAssetQuantity(assets?.length);
        }
    }, [assets?.length, carouselRef.current]);

    useEffect(() => {
        if (assets?.length && !!assets?.[0]?.image?.url) {
            getImageDimensions(assets?.[0]?.image?.url).then((response) => {
                const w = response?.width;
                const h = response?.height;
                setAspectRatioCarousel(getAspectRatio(w, h));
            })
        } else {
            setAspectRatioCarousel("aspect-square");
        }
    }, [assets?.length])

    return (
        <div className={`flex flex-col w-auto !p-0 !overflow-hidden ${className}`}>
            <div className="flex items-center justify-between">
                 {(isEditable || !!preferences?.board_id) && (
                    <BoardDropdown
                        post={post}
                        isEditable={isEditable}
                        onChange={(board_id) => onPreferencesEdit(postIndex, { ...(preferences || {}), board_id: board_id })}
                    />
                 )}
                {!!assets?.[0]?.video?.url && (
                    <Tooltip 
                        title="Customize your YouTube video thumbnail" 
                        wrapperClass="flex justify-stretch"
                    >
                        <MoreOptions
                            onChange={(_preferences) => onPreferencesEdit(postIndex, _preferences)}
                            onCoverEdit={(cover) => onCoverEdit(postIndex, cover)}
                            post={post}
                            isEditable={isEditable}
                            icon={<TbScreenshot className="text-primary-600 text-2xl shrink-0" />}
                            forceShowVideoCover={true}
                            renderClassName="!border-l-0"
                        />
                    </Tooltip>
                )}
            </div>  
            {!!assets?.length 
                ? <Carousel 
                    key={`${assets?.length}_carousel`} 
                    showThumbs={!!assets?.length} 
                    infiniteLoop={false} 
                    autoPlay={false} 
                    className="relative showDots showArrows"
                    ref={carouselRef}
                >
                    {assets?.map((asset, key) => (<>
                        <MediaPreview 
                            asset={asset} 
                            parentClassName="!block"
                            className={`!pointer-events-auto w-full ${aspectRatioCarousel}`} 
                            network={network}
                            isEditable={isEditable}
                            onAssetDelete={() => onAssetDelete(postIndex, key)}
                            onAssetEdit={(src) => onAssetEdit(postIndex, key, src)}
                        />
                    </>))}
                </Carousel>
                : 
                <img src="/img/others/transparent.png" className="aspect-[16/10] bg-gray-200 dark:bg-gray-600 w-full h-full object-cover" />
            }
            {isEditable && 
                <div className="px-4 py-2">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                    />
                </div>
            }
            <div className="p-8 flex flex-col gap-4">
                <div className="flex justify-between items-center text-lg font-bold text-tertiary-700 dark:text-gray-100">
                    <div className="flex gap-8 items-center px-0">
                        <svg className="fill-tertiary-700 dark:fill-gray-100" height="20" width="20" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3M3 9c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm18 0c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3z"></path></svg>
                        <svg className="fill-tertiary-700 dark:fill-gray-100" height="20" width="20" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M21 14c1.1 0 2 .9 2 2v6c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2v-6c0-1.1.9-2 2-2s2 .9 2 2v4h14v-4c0-1.1.9-2 2-2zM8.82 8.84c-.78.78-2.05.79-2.83 0-.78-.78-.79-2.04-.01-2.82L11.99 0l6.02 6.01c.78.78.79 2.05.01 2.83-.78.78-2.05.79-2.83 0l-1.2-1.19v6.18a2 2 0 1 1-4 0V7.66L8.82 8.84z"></path></svg>
                        <svg className="fill-tertiary-700 dark:fill-gray-100" height="20" width="20" viewBox="0 0 24 24" aria-hidden="true" aria-label="" role="img"><path d="M10.52 3.11a2 2 0 013.59 0l2.06 4.17c.02.06.08.1.15.11l4.6.67a2 2 0 011.1 3.41l-3.32 3.25a.2.2 0 00-.06.17l.78 4.58a2 2 0 01-2.9 2.11l-4.11-2.16a.2.2 0 00-.19 0l-4.11 2.16a2 2 0 01-2.9-2.1l.78-4.59a.2.2 0 00-.06-.17l-3.32-3.25a2 2 0 011.1-3.41l4.6-.67a.2.2 0 00.15-.1zm3.9 5.15l-1.75-3.53a.4.4 0 00-.71 0L10.2 8.26a2 2 0 01-1.5 1.1l-3.9.56a.4.4 0 00-.23.69l2.83 2.75a2 2 0 01.57 1.77L7.31 19a.4.4 0 00.58.42l3.5-1.83a2 2 0 011.86 0l3.48 1.83a.4.4 0 00.59-.42l-.67-3.88a2 2 0 01.57-1.77l2.83-2.75a.4.4 0 00-.22-.69l-3.9-.56a2 2 0 01-1.51-1.1z"></path></svg>
                    </div>
                    <div className="">
                    </div>
                </div>
                <LinkPreview 
                    link={link}
                    post={post}
                    network={network}
                    isEditable={isEditable}
                    onLinkEdit={(_link) => onLinkEdit(postIndex, _link)}
                />
                <TitlePreview 
                    title={title}
                    post={post}
                    network={network}
                    isEditable={isEditable}
                    onTitleEdit={(_title) => onTitleEdit(postIndex, _title)}
                />
                <TextPreview 
                    text={text} 
                    network={network} 
                    isEditable={isEditable}
                    post={post}
                    onTextEdit={(value) => onTextEdit(postIndex, value)}
                />
                <div className="flex items-center gap-4">
                    <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="rounded-full h-12 w-12" />
                    <span className="font-bold text-tertiary-700 dark:text-gray-100">{user_name || integration?.name || company?.name}</span>
                </div>
            </div>
        </div>
    )
}

export default PinterestPreview;